export enum ImageErrorCode {
  ImageResolutionTooSmall = 'image-resolution-too-small',
  ImageNotSquare = 'image-not-square',
}
